export default __webpack_public_path__ + "5d4debf59eb96bc86f819f150269b26e.svg";